import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Youtube, Mail, Cookie } from 'lucide-react';

// Function to reset cookie consent and show banner again
const openCookieSettings = () => {
  localStorage.removeItem('ldc_cookie_consent');
  window.location.reload();
};

export default function Footer() {
  return (
    <footer className="bg-stone-800 text-white" data-testid="footer">
      {/* Decorative top border */}
      <div className="h-1 bg-gradient-to-r from-violet-600 via-purple-500 to-violet-600" />
      
      <div className="container mx-auto px-6 lg:px-12 py-12 lg:py-16">
        {/* Main Footer Content - Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          
          {/* Left Side - Large Logo */}
          <div className="flex justify-center lg:justify-start">
            <Link to="/" className="group">
              <img 
                src="https://customer-assets.emergentagent.com/job_dancer-community/artifacts/buaegm7r_1D08A5CF-84D3-4ADA-9A3D-0F8EBE77862A.png" 
                alt="Line Dance Central Logo"
                className="w-48 h-48 sm:w-56 sm:h-56 lg:w-64 lg:h-64 object-contain group-hover:scale-105 transition-transform duration-300"
              />
            </Link>
          </div>
          
          {/* Right Side - Content */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left space-y-6">
            {/* Brand Name */}
            <Link to="/" className="block">
              <div className="flex flex-col items-center lg:items-start" style={{ fontFamily: 'Manrope, sans-serif' }}>
                <span className="text-3xl sm:text-4xl font-extrabold leading-tight">
                  Line Dance
                </span>
                <span className="text-2xl sm:text-3xl font-extrabold text-violet-400 leading-tight -mt-1">
                  Central
                </span>
              </div>
            </Link>
            
            {/* Tagline */}
            <p className="text-stone-300 text-lg max-w-md">
              Your home for discovering local line dance clubs, connecting with instructors, and finding events near you.
            </p>
            
            {/* Email */}
            <a 
              href="mailto:hi@linedancecentral.uk" 
              className="flex items-center gap-2 text-stone-200 hover:text-violet-400 transition-colors text-lg"
            >
              <Mail className="w-5 h-5 text-violet-400" />
              hi@linedancecentral.uk
            </a>
            
            {/* Social Links */}
            <div className="flex gap-3">
              <a href="#" className="w-11 h-11 bg-stone-700 rounded-full flex items-center justify-center hover:bg-violet-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-11 h-11 bg-stone-700 rounded-full flex items-center justify-center hover:bg-violet-600 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-11 h-11 bg-stone-700 rounded-full flex items-center justify-center hover:bg-violet-600 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-11 h-11 bg-stone-700 rounded-full flex items-center justify-center hover:bg-violet-600 transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-stone-700 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-stone-400 text-sm">
            © {new Date().getFullYear()} Line Dance Central. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm text-stone-400">
            <Link to="/blog" className="hover:text-violet-400 transition-colors">Blog</Link>
            <Link to="/privacy" className="hover:text-violet-400 transition-colors">Privacy Policy</Link>
            <Link to="/cookies" className="hover:text-violet-400 transition-colors">Cookie Policy</Link>
            <button 
              onClick={openCookieSettings}
              className="hover:text-violet-400 transition-colors flex items-center gap-1"
            >
              <Cookie className="w-3 h-3" />
              Cookie Settings
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
